import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import "./Home.css";
import { IoLocationOutline } from "react-icons/io5";
import { LuBedSingle } from "react-icons/lu";
import { CiRuler } from "react-icons/ci";
import { FiPhone } from "react-icons/fi";
import { MdOutlineMail } from "react-icons/md";
import { GoLocation } from "react-icons/go";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { FaRegBuilding } from "react-icons/fa";
import { RiCustomerServiceLine } from "react-icons/ri";
import { MdAttachMoney } from "react-icons/md";
import { FaBalanceScale } from "react-icons/fa";
import { GrUserManager } from "react-icons/gr";
import { MdReviews } from "react-icons/md";
import { MdOutlineRealEstateAgent } from "react-icons/md";

const Home = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    category: "",
    city: "",
    type: "",
    minPrice: "",
    maxPrice: "",
  });

  useEffect(() => {
    fetchProperties();
  }, [filters]);

  const fetchProperties = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (filters.category) params.append("category", filters.category);
      if (filters.city) params.append("city", filters.city);
      if (filters.type) params.append("type", filters.type);
      if (filters.minPrice) params.append("minPrice", filters.minPrice);
      if (filters.maxPrice) params.append("maxPrice", filters.maxPrice);
      if (searchQuery) params.append("search", searchQuery);

      const response = await axios.get(`/api/properties?${params.toString()}`);
      setProperties(response.data.slice(0, 6)); // Show only 6 latest properties
      setLoading(false);
    } catch (error) {
      console.error("Error fetching properties:", error);
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchProperties();
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <img src="/assets/img/hero.jpg" className="hero-bg" />

        <div className="overlay"></div>

        <div className="hero-content container">
          <h1 className="hero-title">ابحث عن أفضل العقارات في سوريا</h1>
          <p className="hero-subtitle">
            شقق – بيوت – أراضي – مكاتب – محلات تجارية
          </p>
          <p class="hero-subtitle-en">Find your perfect home in Syria</p>

          <div className="search-box">
            <div className="filters-grid">
              <div className="filter">
                <label>نوع الإعلان</label>
                <select
                  name="type"
                  value={filters.type}
                  onChange={handleFilterChange}
                >
                  <option value="">اختر النوع</option>
                  <option value="buy">للبيع</option>
                  <option value="rent">للإيجار</option>
                </select>
              </div>

              <div className="filter">
                <label>نوع العقار</label>
                <select
                  name="category"
                  value={filters.category}
                  onChange={handleFilterChange}
                >
                  <option value="">اختر النوع</option>
                  <option value="شقة">شقة</option>
                  <option value="منزل">منزل</option>
                  <option value="أرض">أرض</option>
                  <option value="مكتب">مكتب</option>
                  <option value="متجر">متجر</option>
                </select>
              </div>

              <div className="filter">
                <label>المدينة</label>
                <select
                  name="city"
                  value={filters.city}
                  onChange={handleFilterChange}
                >
                  <option value="">اختر المدينة</option>
                  <option value="دمشق">دمشق</option>
                  <option value="حلب">حلب</option>
                  <option value="حمص">حمص</option>
                  <option value="حماة">حماة</option>
                  <option value="اللاذقية">اللاذقية</option>
                  <option value="طرطوس">طرطوس</option>
                </select>
              </div>

              <div className="filter">
                <label>أقل سعر</label>
                <input
                  type="number"
                  name="minPrice"
                  placeholder="0"
                  value={filters.minPrice}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter">
                <label>أعلى سعر</label>
                <input
                  type="number"
                  name="maxPrice"
                  placeholder="100,000"
                  value={filters.maxPrice}
                  onChange={handleFilterChange}
                />
              </div>
            </div>

            <form className="hero-search" onSubmit={handleSearch}>
              <input
                type="text"
                placeholder="ابحث عن عقار..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="btn-primary">
                بحث
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Featured Properties */}
      <section className="featured-properties">
        <div className="container">
          <div className="heading">
            <h2>العقارات المضافة حديثًا</h2>
            <p>اكتشف أحدث العروض المتوفرة بجميع المحافظات السورية</p>
          </div>

          {loading ? (
            <div className="loading">
              <div className="spinner"></div>
            </div>
          ) : properties.length > 0 ? (
            <div className="properties-grid">
              {properties.map((property) => (
                <Link
                  to={`/property/${property.id}`}
                  key={property.id}
                  className="property-card"
                >
                  <div className="property-image">
                    {property.images && property.images.length > 0 ? (
                      <img
                        src={`/api${property.images[0]}`}
                        alt={property.title}
                      />
                    ) : (
                      <div className="no-image">لا توجد صورة</div>
                    )}
                    <span className="property-type">
                      {property.type === "buy" ? "للبيع" : "للإيجار"}
                    </span>
                  </div>
                  <div className="property-info">
                    <h3>{property.title}</h3>
                    <p className="property-location">
                      <IoLocationOutline /> {property.city}
                    </p>
                    <div className="property-details">
                      <p>
                        {property.rooms && (
                          <>
                            <span>
                              <LuBedSingle />{" "}
                            </span>
                            <span>{property.rooms} غرف</span>
                          </>
                        )}
                      </p>
                      <p>
                        {property.area && (
                          <>
                            <span>
                              <CiRuler />
                            </span>
                            <span> م² {property.area} </span>
                          </>
                        )}
                      </p>
                    </div>
                    <p className="property-price">
                      {property.price.toLocaleString()} ل.س
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <h3>لا توجد عقارات متاحة</h3>
              <p>جرب تغيير معايير البحث</p>
            </div>
          )}
          <div className="view-all">
            <Link to="/properties" className="btn btn-primary">
              عرض جميع العقارات
            </Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="container">
          <div className="about-content">
            <div className="heading">
              <p>من نحن</p>
              <h2 class="section-title">منصة سوريا للعقارات</h2>
            </div>

            <div class="company-content">
              <p>
                نحن منصة عقارية سورية تقدم خدمات بيع وشراء وتأجير العقارات بجميع
                أنواعها في مختلف المحافظات السورية، مع إتاحة التواصل المباشر مع
                المالك أو المكتب العقاري.
              </p>
            </div>
            <div className="about-cards">
              <div className="about-card">
                <IoShieldCheckmarkOutline className="icon" />
                <h3>الوثوقية العالية</h3>
                <p>
                  نعمل بوضوح وشفافية في جميع الإعلانات والمعلومات لضمان تجربة
                  آمنة بعيدًا عن المعلومات الخاطئة أو المضللة.{" "}
                </p>
              </div>
              <div className="about-card">
                <GoLocation className="icon" />
                <h3>الخبرة المحلية</h3>
                <p>
                  فريقنا يمتلك خبرة كبيرة بالسوق العقاري السوري، وأسعاره،
                  والمناطق، مما يساعدك على اتخاذ القرار الأفضل.{" "}
                </p>{" "}
              </div>
              <div className="about-card">
                <FaRegBuilding className="icon" />
                <h3>تنوع كبير بالعقارات</h3>
                <p>
                  سواء تبحث عن شقة، منزل، مكتب، أرض أو عقار تجاري — ستجد لدينا
                  خيارات تناسب جميع المتطلبات.
                </p>
              </div>
              <div className="about-card">
                <RiCustomerServiceLine className="icon" />
                <h3>دعم العملاء</h3>
                <p>فريق متخصص جاهز للرد على أسئلتك وتوجيهك خطوة بخطوة.</p>
              </div>
              <div className="about-card">
                <MdAttachMoney className="icon" />
                <h3>أسعار تنافسية</h3>
                <p>
                  نعتمد على أسعار السوق الحقيقية ونتعامل بشفافية دون عمولات أو
                  شروط خفية.
                </p>
              </div>
              <div className="about-card">
                <FaBalanceScale className="icon" />
                <h3>التزام كامل بالشفافية</h3>
                <p>
                  جميع العقارات تظهر بالصور والمعلومات الحقيقية لضمان الثقة بين
                  الطرفين.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="statistics-section" id="statistics">
        <div className="container">
          <div className="heading">
            <p className="section-subtitle">إحصائياتنا</p>
            <h2 className="section-title">نحن نتميز بالنتائج</h2>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <h3>+10</h3>
              <p>سنوات خبرة</p>
            </div>
            <div className="stat-card">
              <h3>+250</h3>
              <p>عقار تم بيعه</p>
            </div>
            <div className="stat-card">
              <h3>+180</h3>
              <p>عميل سعيد</p>
            </div>
            <div className="stat-card">
              <h3>+20</h3>
              <p>مدينة نخدمها</p>
            </div>
          </div>
        </div>
      </section>
      <section className="company-info-section">
        <div className="container">
          <div className="company-grid">
            {/* Brand / Logo */}
            <div className="company-card brand-card">
              <div className="icon-circle">
                <MdOutlineRealEstateAgent
                  style={{ fontSize: "35px", color: "white" }}
                />
              </div>
              <h2>سوريا للعقارات</h2>
              <p className="slogan-ar">
                أول موقع إلكتروني متخصص بالعقارات بسوريا
              </p>
              <p className="slogan-en">
                The first website specializing in real estate
              </p>
            </div>

            {/* General Manager */}
            <div className="company-card manager-card">
              <div className="icon-circle">
                <GrUserManager style={{ fontSize: "35px", color: "white" }} />{" "}
              </div>
              <h3>المدير العام</h3>
              <p className="manager-name-ar">الدكتور وضاح السعيد</p>
              <p className="manager-name-en">Dr. Waddah Saheed</p>
              <p className="manager-position">General Manager</p>
            </div>

            {/* Company Overview / Values */}
            <div className="company-card overview-card">
              <div className="icon-circle">
                <MdReviews style={{ fontSize: "35px", color: "white" }} />{" "}
              </div>
              <h3>عن الشركة</h3>
              <p>
                نحن منصة عقارية سورية تقدم خدمات بيع وشراء وتأجير العقارات بجميع
                أنواعها في مختلف المحافظات، مع توفير تجربة سهلة وآمنة للعملاء.
              </p>
              <div className="values-list">
                <div className="value-item">🔹 موثوقية عالية</div>
                <div className="value-item">🔹 خبرة محلية عميقة</div>
                <div className="value-item">🔹 تنوع كبير بالعقارات</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact">
        <div className="container">
          <p className="section-subtitle">اتصل بنا</p>
          <h2 className="section-title">نحن هنا لمساعدتك</h2>
          <div className="contact-info-grid">
            <div className="contact-card">
              <div className="contact-icon">
                <FiPhone />
              </div>
              <h3>هاتف سوريا</h3>
              <a href="tel:+963985148289">+963 985 148 289</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">
                <FiPhone />
              </div>
              <h3>هاتف السعودية</h3>
              <a href="tel:+966535706325">+966 535 706 325</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">
                <MdOutlineMail />
              </div>
              <h3>البريد الإلكتروني</h3>
              <a href="mailto:info@syrianrealestate.net">
                info@syrianrealestate.net
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
